import React, { useContext, useEffect, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { addcontext } from '../../ContextShare/ContextShare';
// import AddNewEvent from './AddNewEvent';
import { Icon } from '@iconify/react';
import { EditSittings, FiterSitingsTableAdmin, GetKlaListForSearchFilter, GetSessionListForSearchFilter, GetSessionListForSearchFilterWithKla, updatePdfLink } from '../../Services/allApi';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
// import Select from "react-select";
import { GetSittings, DeleteSittings } from '../../Services/allApi';
import DeleteModal from '../DeleteModal';
import PopOver from '../../Components/PopOver';
import { toast, ToastContainer } from 'react-toastify';
// import EditSittings from '../Session/EditSittings';
import SyncLoader from "react-spinners/SyncLoader";
import '../loaderStyles.css'
import { useNavigate } from 'react-router-dom';
import Select, { components } from 'react-select';

const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;

    if (data.value === 'addnewkla' || data.value === 'addnewsession') {
        return (
            <div
            className='hover:bg-green-500 hover:text-white text-green-500'
                ref={innerRef}
                {...innerProps}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    // backgroundColor: 'lightyellow',
                    padding: '10px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }}
            >
                <span className='font-bold' >{data.label}</span>
                <Icon icon="basil:add-outline" className='ms-1 font-bold' />

            </div>
        );
    }

    return <components.Option {...props} />;
};
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90%',
    overflowY: 'hidden' // Make the Box scrollable
};

const style4 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function ManageSittingsTable() {
    const { addEvent, setaddEvent } = useContext(addcontext)
    const [editBox, setEditBox] = useState(false)
    const [SessionList, setSessionList] = useState([])
    const [klaList, setKlaList] = useState([])
    const [dataToEdit, setDataToEdit] = useState()
    const [open, setOpen] = useState(false);
    const [sessionOptions, setSessiOnoptions] = useState([]);
    const [klaoptions, setKlaOptions] = useState([]);
    const [isEdited, setIsEdited] = useState(1)
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [tableDetails,setTableDetails]=useState()
    const [dataForPdf,setdataForPdf]=useState()
    const [dataForPdf2,setdataForPdf2]=useState()
    const [selectedOptionKla, setSelectedOptionKla] = useState(null);
    const [selectedOptionsession, setSelectedOptionsession] = useState(null);
    const [klaListF, setKlaListF] = useState([]);
    const [sessionListF, setSessionListF] = useState([]);
   const[sittingsDataInPdfUpdateModal,setsittingsDataInPdfUpdateModal]=useState()
    const [idToDelete,setidToDelete]=useState()
    const [idToPdfUpdate,setidToPdfUpdate]=useState()
    const [errorMsg, setErrorMsg] = useState()

  const navigate=useNavigate()
    const [open4, setOpen4] = useState(false);
    const handleOpen4 = (IdToDlt) => {
        setidToDelete(IdToDlt)
        setOpen4(true);}
    const handleClose4 = () => {
        setOpen4(false);
    }

    const [openP, setOpenP] = useState(false);
    const handleOpenP = () => setOpenP(true);
    const handleCloseP = () => setOpenP(false);


    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',

                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',

            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',

            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,


                    // backgroundColor:'red'
                },
            },
        },

    };
    const [eventList, setEventList] = useState([])
    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,
        },
        {
            name: 'Id',
            selector: row => row.id,
            sortable: true,
        },
        { 
            name: 'Action',
            selector: row => row.Action,
            // sortable: true,
        },
        { 
            name: 'Pdf',
            selector: row => row.pdf,
            minWidth: '110px', // Adjust the width as needed
            // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
            maxWidth: '150px',
        
            // sortable: true,
        },
        {
            name: 'KLA',
            selector: row => row.kla,
            sortable: true,
        },
        {
            name: 'Session',
            selector: row => row.session,
            sortable: true,


        },
        // {
        //     name: 'KLA',
        //     selector: row => row.kla,
        //     sortable: true,


        // },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: true,
        },
        
        {
            name: 'Sitting Date',
            selector: row => row.sitting_date,
            sortable: true,
        },
        {
            name: 'Pdf Link',
            selector: row => row.pdfView,
            sortable: true,
        },
        // {
        //     name: 'Active',
        //     selector: row => row.Visible,
        //     sortable: true,
        // },
        {
            name: 'Uploaded By',
            selector: row => row.uploaded_by,
            sortable: true,
        },
        {
            name: 'Created At',
            selector: row => row.created_at,
            sortable: true,
        },
        {
            name: 'Updated At',
            selector: row => row.updated_at,
            sortable: true,
        },
        {
            name: 'Delete',
            selector: row => row.active,
            // sortable: true,
        },
    ];
    useEffect(() => {
        geteventcall()
    }, [isEdited])

    const geteventcall = async () => {
        const result = await GetSittings()
        setEventList(result?.data?.data)
        setErrorMsg(result?.response?.data?.message)

        console.log(result?.data?.data);
    }

    const deleteRow=async()=>{
        handleClose4()
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response=await DeleteSittings(idToDelete,reqHeader)
        // console.log(response);
        setIsEdited(isEdited+1)
    
       }
    var data = []
    eventList?.length>0 && eventList?.map((item, index) => {
        const slno = index + 1
        const id = item.id;
        const kla = item.kla
        const session = item.session;
        // const kla=item.kla
        const description = item.description;
        const sitting_date = item.sitting_date
        const pdfView = item.pdf_link

        const created_at = item.created_at.slice(0,10)
        const updated_at = item.updated_at.slice(0,10)

        const uploaded_by = item.uploaded_by

        const active = <div className='flex flex-row justify-center items-center text-red-500 p-1 rounded' style={{ cursor: 'pointer' }}>
        <button className='' onClick={() => handleOpen4(item.id)} >Delete</button>
        <Icon icon="ic:outline-delete" className='text-lg' />
    </div>

         const Visible = item.is_active ? <Icon icon="fa-solid:check-circle" style={{ color: 'green' }} /> : <Icon icon="fa-solid:times-circle" style={{ color: 'red' }} />;
       
         const Action = <a style={{ color: '#18A0FB', cursor: 'pointer' }} onClick={() => handleEdit(item)}>Edit</a>;
         const pdf= <button className='px-2 py-1 text-white rounded'  style={{ backgroundColor: '#18A0FB'}} onClick={()=>handlePdfUpdateModal(item)}>Update pdf</button>;
        

        const newObj = { slno,id,session,description, sitting_date,created_at, updated_at, uploaded_by, active, Action, Visible,pdf,pdfView,kla };
        data.push(newObj);
    })



    const handleEdit = (item) => {
        setEditBox(true)
        setDataToEdit(item)
        handleOpen()
        setTableDetails(item)


    }

   
    const handleSubmitEdit = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        // console.log(dataToEdit);
        const result = await EditSittings(dataToEdit, reqHeader)
        if(result.status==200){
            handleClose()
            setIsEdited(isEdited + 1)
            toast.success("Editing successful")
        }else{
            toast.error(result?.response?.data?.message??"There was an error editing sitting")
        }
        // console.log(result);
    }

     // ------------------------------------------FILTER IN VIDEO----------------------------------------------
    // Fetch KLA List for filter
    const klaListCallApiFilter = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            setKlaListF(result?.data?.data || []);
        } catch (error) {
            console.error("Error fetching KLA list for filter:", error);
        }
    };

    useEffect(() => {
        klaListCallApiFilter();
    }, []);

    const klaoptionsF = klaListF.map((item) => ({
        value: item.kla_id,
        label: `KLA${item.kla_no}`,
    }));

    // Fetch Session List
    const SessionListCallApiFilter = async () => {
        try {
            const resultSession = selectedOptionKla
                ? await GetSessionListForSearchFilterWithKla(selectedOptionKla.value)
                : await GetSessionListForSearchFilter();
            setSessionListF(resultSession?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Session list for filter:", error);
        }
    };

    useEffect(() => {
        SessionListCallApiFilter();
    }, [selectedOptionKla]);

    const sessionoptionsF = sessionListF.map((item) => ({
        value: item.session_id,
        label: `Session${item.session_no}`,
    }));

    const handlechange = (option) => {
        if(option?.value=='addnewkla'){
            navigate('/octobersky/kla')
        }
        else{
        setSelectedOptionKla(option)
        }}
    const handlechangesession = (option) =>{
        if(option?.value=='addnewsession'){
            navigate('/octobersky/session')
        }
        else{
            setSelectedOptionsession(option);
        }
        }

    const FilterAdmin = async () => {
        const kla_id = selectedOptionKla?.value;
        const session_id = selectedOptionsession?.value;
        // const member_id = selectedOptionMember?.value;
        // const event_id = selectedOptionEvent?.value;
        // const constituency_id = selectedOptionconstituency?.value;

        const obj = {};
        if (kla_id) obj.kla_id = kla_id;
        if (session_id) obj.session_id = session_id;
        // if (member_id) obj.member_id = member_id;
        // if (event_id) obj.event_id = event_id;
        // if (constituency_id) obj.constituency_id = constituency_id;

        try {
            const token = sessionStorage.getItem('access_token')
            const reqHeader = {
                "Content-Type": "application/json",
                "Authorization": `${token}`
            };
            const result = await FiterSitingsTableAdmin(obj,reqHeader);
            setEventList(result?.data?.data || []);
            setErrorMsg(result?.response?.data?.message)
            console.log(result);
            
        } catch (error) {
            console.error("Error filtering archives data:", error);
        }
    };

    useEffect(() => {
        if(selectedOptionKla||selectedOptionsession){
        FilterAdmin();}
    }, [selectedOptionKla, selectedOptionsession]);

    // ------------------------------------------FILTER IN VIDEO END----------------------------------------------
    

      const handlePdfUpdateModal=(item)=>{
        setdataForPdf(item?.pdf_link)
        setdataForPdf2(item?.pdf_link2)
        setidToPdfUpdate(item?.id)
        setsittingsDataInPdfUpdateModal(item)
        handleOpenP()
      }
const handleSubmitPdfUpdate=async()=>{
    const newPdf={
        id:idToPdfUpdate,
        pdf_link:dataForPdf,
        pdf_link2:dataForPdf2
    }
    const token = sessionStorage.getItem('access_token')
    const reqHeader = {
        "Content-Type": "application/json",
        "Authorization": `${token}`
    };
    // console.log(newPdf);
    const res=await updatePdfLink(newPdf,reqHeader)
    if(res?.status==200){
        handleCloseP()
        setIsEdited(isEdited + 1)
        toast.success("Pdf link added successfully")
    }
    else{
        toast.error(res?.data?.message?.pdf_link[0]??'There was an error')
        console.log(res);
    }
}
const handleResetFilter=()=>{
    setSelectedOptionKla(null)
    setSelectedOptionsession(null)
    geteventcall()
    // setSelectedOptionsession(null)
    // GetProgressList()
    setErrorMsg()
   
}

    return (
        <>

<div className='flex flex-row justify-center gap-5'>
                        <div className='flex flex-row w-3/12  text-blue-400'>
                    
                    <Select
                        placeholder='KLA'
                        className='w-full'
                         options={[ ...klaoptionsF,{ value: 'addnewkla', label: 'Add new kla' }]}
                        value={selectedOptionKla}
                        onChange={handlechange}
                        components={{ Option: CustomOption }}
                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderRadius: '0.5rem',
                            }),
                        }}
                        />
                </div>

                <div className='flex flex-row w-3/12 text-blue-400'>
                    <Select
                        placeholder='Session'
                        className='w-full'
                        options={[ ...sessionoptionsF,{ value: 'addnewsession', label: 'Add new session' }]}

                                value={selectedOptionsession}
                                onChange={handlechangesession}
                                components={{ Option: CustomOption }}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderRadius: '0.5rem',
                                    }),
                                }}
                        />
                </div>
                <div className='flex flex-col '>
                            <button onClick={handleResetFilter} className='flex flex-row gap-1 items-center rounded-lg w-full hover:bg-red-500 border text-red-500 hover:text-white border-red-500 h-9 px-2 transform duration-700 ease-in-out'>
                                <span>Clear Filter</span>
                                <Icon icon="bx:reset" />
                                    </button>
                        </div>

                    </div>
                    <>
                    {eventList?.length>0?

                <DataTable
                title={<div className='flex flex-row items-center'><span className='me-2'>Sittings List</span> <PopOver dataToDisplay={'Add Edit Sittings'} /></div>}
                columns={columns}
                    data={data}
                    customStyles={customStyles}
                    pagination
                    dense
                    highlightOnHover
                    selectableRowsHighlight
                    paginationRowsPerPageOptions={[25, 50, 100, 200, 500]} // Options for users to change page size
                // selectableRows
                // progressPending
                // progressComponent={<h1>load</h1>}
                />
                :
                <>
               {!errorMsg?<div className="flex justify-center items-center w-full h-full flex-col gap-5">
                <SyncLoader 
                  color="#3498db"
                  loading={true}
                  speedMultiplier={1}
                />
                        <p className="loading-text flex flex-row items-center"><span>Loading please wait</span><Icon className='text-lg' icon="eos-icons:three-dots-loading" /></p>
        
              </div>
              :
              <div className="flex justify-center items-center w-full h-full flex-col gap-5">
              <p className="text-red-500 flex flex-row items-center text-lg gap-1"><span>{errorMsg}</span><Icon icon="material-symbols:error-outline" className='text-lg' /></p>
              </div>
              }
              </>
              }
                </>

<Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex flex-col items-center justify-center w-full ' style={{ fontFamily: 'ropa sans' }}>

                        <div className='flex justify-around w-full'>
                        <p className='text-blue-500'> Sittings Id: {dataToEdit?.id}</p> 
                        <p className='text-blue-500'> Session: {dataToEdit?.session}</p> 
                        </div>
                        
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field3">Description</label>
                            <input
                                id='field3'
                                placeholder={dataToEdit?.description}
                                value={dataToEdit?.description}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, description: e.target.value })}
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>
                        
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field3">Description malayalam</label>
                            <input
                                id='field3'
                                placeholder={dataToEdit?.malayalam_description}
                                value={dataToEdit?.malayalam_description}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, malayalam_description: e.target.value })}
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>
                       
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field4">Date</label>
                            <input
                                id='field4'
                                value={dataToEdit?.sitting_date}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, sitting_date: e.target.value })}
                                type="date"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        {/* End of additional fields */}
                        <div className='flex flex-row justify-center mb-5 mt-10'>
                            <button className='px-4 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitEdit}>Submit</button>
                            <button className='px-4 py-2 bg-success rounded-full ms-2' onClick={handleClose}>Cancel</button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={openP}
                onClose={handleCloseP}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex flex-col items-center justify-center w-full ' style={{ fontFamily: 'ropa sans' }}>

                        <div className='flex justify-around w-full'>
                        <p className='text-blue-500'> Sittings Id: {sittingsDataInPdfUpdateModal?.id}</p> 
                        <p className='text-blue-500'> Session: {sittingsDataInPdfUpdateModal?.session}</p> 
                        </div>
                        

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field3">List of business</label>
                            <input
                                id='field3'
                                // placeholder={dataToEdit?.description}
                                value={dataForPdf}
                                // onChange={(e) => setDataToEdit({ ...dataToEdit, description: e.target.value })}
                                onChange={(e)=>setdataForPdf(e.target.value)}
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field4">List of proceeding</label>
                            <input
                                id='field4'
                                // placeholder={dataToEdit?.description}
                                value={dataForPdf2}
                                // onChange={(e) => setDataToEdit({ ...dataToEdit, description: e.target.value })}
                                onChange={(e)=>setdataForPdf2(e.target.value)}
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>


                        {/* End of additional fields */}
                        <div className='flex flex-row justify-center mb-5 mt-10'>
                            <button className='px-4 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitPdfUpdate}>Submit</button>
                            <button className='px-4 py-2 bg-success rounded-full ms-2' onClick={handleCloseP}>Cancel</button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
        open={open4}
        onClose={handleClose4}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        >
        <Box sx={style4}>
        <DeleteModal deleteRow={deleteRow} handleClose4={handleClose4} open4={open4}/>
        </Box>
        </Modal>

        <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
        theme="light"
      />
        
        </>
    )
}

export default ManageSittingsTable